const footerColumns = [
  {
    title: "片库",
    links: [
      { label: "最新电影", href: "#movies" },
      { label: "热播剧精选", href: "#featured" },
      { label: "电视剧片库", href: "#series" },
      { label: "经典老剧", href: "#classics" },
    ],
  },
  {
    title: "发现",
    links: [
      { label: "追剧榜单", href: "#ranking" },
      { label: "按类型看片", href: "#movies" },
      { label: "追剧指南", href: "#guide" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "站点首页", href: "#top" },
      { label: "资源更新", href: "#faq" },
      { label: "使用帮助", href: "#guide" },
      { label: "浏览须知", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 pt-14 pb-8">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">星辰影视</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              星辰影视片库收录最新电影、电视剧与热播剧，覆盖多类型片源。无论想看热门新片还是经典老剧，都能在这里快速找到想看的那一部，畅享一站式追剧体验。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["科幻", "悬疑", "剧情", "动作", "爱情", "古装"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-background-50/10 px-3 py-1 font-label text-xs text-background-100"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                <a href={column.links[0].href} className="hover:text-primary-300">
                  {column.title}
                </a>
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-background-200 transition-colors hover:text-primary-300">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/10 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 星辰影视 · 本站页面内容为示例展示，片名与简介仅用于演示浏览体验。</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line"></i>
            仅提供片库浏览与筛选演示，不含真实播放与下载
          </p>
        </div>
      </div>
    </footer>
  );
}